import { MemoizedSelector, createSelector } from '@ngrx/store';
import { SiteContextState, StateWithSiteContext } from '../site-context-state';
import { getSiteContextState } from './site-context.selector';

export const getSitePrefix: MemoizedSelector<StateWithSiteContext, string> = createSelector(
  getSiteContextState,
  (state: SiteContextState) => state && state.sitePrefix
);
